import { Composer } from '@liveblocks/react-ui/primitives'

import { SuggestionUser } from './suggestion-user'

type MentionSuggestionItemProps = {
  userId: string
}

export const MentionSuggestionItem = ({ userId }: MentionSuggestionItemProps) => (
  <Composer.SuggestionsListItem
    value={userId}
    className='flex cursor-pointer items-center gap-2 px-2 py-1 text-main-foreground-primary text-body-default data-[selected]:bg-main-background-interactive-list-hover'
  >
    <SuggestionUser userId={userId} />
  </Composer.SuggestionsListItem>
)
